import { type ClassValue, clsx } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

const twMerge = extendTailwindMerge({
    override: {
        conflictingClassGroups: {
            'font-size': [],
        },
    },
});

export function cn(...inputs: ClassValue[]) {
    return twMerge(clsx(inputs));
}

export function pluralize(count: number, singular: string, plural?: string) {
    return count === 1 ? `${count} ${singular}` : `${count} ${plural ?? `${singular}s`}`;
}
